export type FloorLevel = "1/F" | "M/F" | "2/F" | "3/F";

export const getFacilityFloor = (queryId: string): FloorLevel | null => {
  const floorMappings: Record<string, FloorLevel> = {
    // 1/F
    "1A_COUNTER": "1/F",
    "1A_BOOK": "1/F",
    "1C_BOOK": "1/F",
    "1A_BOOK_RESERVE": "1/F",
    "1B_BOOK_LEFT": "1/F",
    "1B_BOOK_LATE": "1/F",
    "1B_BOOK_RIGHT": "1/F",
    "2C_MEDIA_III": "1/F",
    "2A_SPECIAL": "1/F",
    "1A_IC": "1/F",
    "1B_COMPROOM2": "1/F",
    "1B_COMPROOM1_2": "1/F",
    "1B_SEN1": "1/F",
    "1C_SEN2": "1/F",
    "1B_BLOOMBERG": "1/F",
    "1B_LSEG": "1/F",
    "1B_WIND": "1/F",
    "1A_1B_MFP": "1/F",
    "1C_INDIVROOM_1_7": "1/F",
    "1C_INDIVROOM_8": "1/F",
    "1A_INDIVROOM_9_11": "1/F",
    "1C_GROUPROOM_1_4": "1/F",
    "1C_GROUPROOM_5": "1/F",
    "1C_GROUPROOM_6_7": "1/F",
    "1A_GROUPROOM_8_9": "1/F",
    "1B_LATE": "1/F",
    "1B_PG_CARREL": "1/F",
    "1A_CARREL": "1/F",
    "1C_CARREL": "1/F",
    "1A_ACTIVITYROOM": "1/F",
    "1A_CAFE": "1/F",
    "1B_WATER": "1/F",
    "1A_1C_MFTOILET": "1/F",
    "1A_1C_ACCTOILET": "1/F",
    "1B_TOILET": "1/F",
    "1B_BOOKDROP": "1/F",
    "1B_STERILSER": "1/F",
    "1B_SELF_CHECKOUT": "1/F",
    "1B_SELF_PICKUP": "1/F",
    "1B_SEN": "1/F",
    "1A_LUBARN_LASER": "1/F",
    "1B_LIFT": "1/F",

    // M/F
    "MB_BOOK": "M/F",
    "MA_LUBARN": "M/F",
    "MC_CARREL": "M/F",
    "MC_PG_LOUNGE": "M/F",
    "MA_LUBARN_3DPRINTER": "M/F",
    "MA_LUBARN_3DSCANNER": "M/F",
    "MB_LIFT": "M/F",

    // 2/F
    "2A_NEW_JOURNAL": "2/F",
    "2A_OLD_JOURNAL": "2/F",
    "2B_BOOK": "2/F",
    "2A_MEDIA": "2/F",
    "2B_NEWS": "2/F",
    "2A_OLD_NEWS": "2/F",
    "Ref_A-HM": "2/F",
    "Ref_HN-Z": "2/F",
    "2C_MLLC": "2/F",
    "2A_CHANG": "2/F",
    "2B_THEATRE": "2/F",
    "2A_2C_MFP": "2/F",
    "2B_GROUPROOM_10_11": "2/F",
    "2A_WATER": "2/F",
    "2C_MFTOILET": "2/F",
    "2B_LIFT": "2/F",

    // 3/F
    "3A_BOOK": "3/F",
    "3B_BOOK": "3/F",
    "3C_BOOK": "3/F",
    "3A_BOOK_LBK": "3/F",
    "3C_MULTIROOM1": "3/F",
    "3A_MULTIROOM2": "3/F",
    "3B_MFP": "3/F",
    "3A_3C_WATER": "3/F",
    "3A_MTOILET": "3/F",
    "3C_FTOILET": "3/F",
    "3C_ACCTOILET": "3/F",
    "3B_LIFT": "3/F",
  };

  return floorMappings[queryId] || null;
};

export const mapCategoryToFacility = (categoryName: string): string => {
  const facilityMap: Record<string, string> = {
    // Service Counter
    "Service Counter (1/F Zone A)": "1A_COUNTER",

    // Collections
    "Books A-DS776 (1/F Zone A)": "1A_BOOK",
    "Books DS777-HJ (1/F Zone C)": "1C_BOOK",
    "Books HM (M/F Zone B)": "MB_BOOK",
    "Books HN-HS (3/F Zone A)": "3A_BOOK",
    "Books HT-NX (3/F Zone B)": "3B_BOOK",
    "Books P-ZA (3/F Zone C)": "3C_BOOK",
    "Course Reserves (1/F Zone A)": "1A_BOOK_RESERVE",
    "Good Reads, New Arrivals (1/F Zone B)": "1B_BOOK_LEFT",
    "High Use Books (1/F Zone B)": "1B_BOOK_LATE",
    "Current Journals (2/F Zone A)": "2A_NEW_JOURNAL",
    "Bound Journals (2/F Zone A)": "2A_OLD_JOURNAL",
    "Language Examinations & Learning Resources [LANG] (2/F Zone B)": "2B_BOOK",
    "Large Books [LBK], Extra Large Books [XLBK] (3/F Zone A)": "3A_BOOK_LBK",
    "Special Collections - Ask at Service Counter (1/F Zone A)": "1A_COUNTER",
    "Multimedia (2/F Zone A)": "2A_MEDIA",
    "Category III Multimedia - Ask at Service Counter (1/F Zone A)": "2C_MEDIA_III",
    "Current Issues (2/F Zone B)": "2B_NEWS",
    "Back Issues (2/F Zone A)": "2A_OLD_NEWS",
    "References A-HM (2/F Zone A)": "Ref_A-HM",
    "References HN-Z (2/F Zone C)": "Ref_HN-Z",
    "Staff Publications (1/F Zone B)": "1B_BOOK_RIGHT",

    // Computers
    "Chiang Chen Information Commons (1/F Zone A)": "1A_IC",
    "Computer Room 2 (1/F Zone B)": "1B_COMPROOM2",
    "Lee Hak Kan Multimedia and Language Learning Centre - MLLC (2/F Zone C)": "2C_MLLC",
    "SEN Workstation 1 (1/F Zone B)": "1B_SEN1",
    "SEN Workstation 2 (1/F Zone C)": "1C_SEN2",
    "Bloomberg Terminal - Database Workstation (1/F Zone B)": "1B_BLOOMBERG",
    "LSEG Workspace (1/F Zone B)": "1B_LSEG",
    "WIND 資訊金融終端 (1/F Zone B)": "1B_WIND",

    // MultiFunction Printers
    "11-15, 16BW (1/F Zone A & Zone B)": "1A_1B_MFP",
    "21, 22BW, 23 (2/F Zone A & Zone C)": "2A_2C_MFP",
    "31BW (3/F Zone B)": "3B_MFP",

    // Study Rooms
    "Individual Study Rooms 1 - 7 (1/F Zone C)": "1C_INDIVROOM_1_7",
    "Individual Study Room 8 (1/F Zone C)": "1C_INDIVROOM_8",
    "Individual Study Rooms 9 - 11 (1/F Zone A)": "1A_INDIVROOM_9_11",
    "Group Study Rooms 1 - 4 (1/F Zone C)": "1C_GROUPROOM_1_4",
    "Group Study Room 5 (1/F Zone C)": "1C_GROUPROOM_5",
    "Group Study Rooms 6 - 7 (1/F Zone C)": "1C_GROUPROOM_6_7",
    "Group Study Rooms 8 - 9 (1/F Zone A)": "1A_GROUPROOM_8_9",
    "Group Study Rooms 10 - 11 (2/F Zone B)": "2B_GROUPROOM_10_11",

    // Quiet Study Spaces
    "Late Reading Room (1/F Zone B)": "1B_LATE",
    "Postgraduate Research Carrels (1/F Zone B)": "1B_PG_CARREL",
    "Individual Study Carrels (1/F Zone A)": "1A_CARREL",
    "Individual Study Carrels (1/F Zone C)": "1C_CARREL",
    "Individual Study Carrels (M/F Zone C)": "MC_CARREL",
    "Postgraduate Lounge (M/F Zone C)": "MC_PG_LOUNGE",
    "Chang Han-tsiu Reading Room (2/F Zone A)": "2A_CHANG",
    "Multi-Purpose Room 1 (3/F Zone C)": "3C_MULTIROOM1",
    "Multi-Purpose Room 2 (3/F Zone A)": "3A_MULTIROOM2",

    // Group Study Spaces
    "Activity Room (1/F Zone A)": "1A_ACTIVITYROOM",
    "Café (1/F Zone A)": "1A_CAFE",
    "Computer Rooms 1 & 2 (1/F Zone B)": "1B_COMPROOM1_2",
    "LU Barn (Makerspace) (M/F Zone A)": "MA_LUBARN",
    "Mini Theatre (2/F Zone B)": "2B_THEATRE",

    // Drinking Water Stations
    "1/F (1/F Zone B)": "1B_WATER",
    "2/F (2/F Zone A)": "2A_WATER",
    "3/F (3/F Zone A & Zone C)": "3A_3C_WATER",

    // Toilets
    "Female & Male Toilets (Zone A & Zone C)": "1A_1C_MFTOILET",
    "Accessible Toilets (Zone A & Zone C)": "1A_1C_ACCTOILET",
    "Unisex - Available during Overnight Study Period (Zone B)": "1B_TOILET",
    "Female & Male Toilets (Zone C)": "2C_MFTOILET",
    "3/F Male (Zone A)": "3A_MTOILET",
    "3/F Female (Zone C)": "3C_FTOILET",
    "3/F Accessible Toilet (Zone C)": "3C_ACCTOILET",

    // Other Facilities
    "Book Drop (1/F Zone B)": "1B_BOOKDROP",
    "Book Sterilizer (1/F Zone B)": "1B_STERILSER",
    "Self-Checkout Machine (1/F Zone B)": "1B_SELF_CHECKOUT",
    "Self-Pickup Locker (1/F Zone B)": "1B_SELF_PICKUP",
    "SEN Equipment - Service Counter (1/F Zone B)": "1B_SEN",
    "3D Printers - LU Barn (Makerspace) (M/F Zone A)": "MA_LUBARN_3DPRINTER",
    "3D Scanner - LU Barn (Makerspace) (M/F Zone A)": "MA_LUBARN_3DSCANNER",
    "Laser Cutter / Engraver - LU Barn (Makerspace) Maker Room (1/F Zone A)": "1A_LUBARN_LASER",
    "Lift (1/F Zone B)": "1B_LIFT",
    "Lift (M/F Zone B)": "MB_LIFT",
    "Lift (2/F Zone B)": "2B_LIFT",
    "Lift (3/F Zone B)": "3B_LIFT",
  };

  return facilityMap[categoryName] || categoryName;
};

export const SPECIAL_FACILITY_URLS: Record<string, string> = {
  "Late Reading Room (1/F Zone B)": "https://pwwpdev.github.io/Lingnan/lrr_facility.html",
  "Individual Study Carrels (M/F Zone C)": "https://pwwpdev.github.io/Lingnan/mfc_facility.html",
};
